import { render, staticRenderFns } from "./LogOrders.vue?vue&type=template&id=56d4b73e&"
import script from "./LogOrders.vue?vue&type=script&lang=js&"
export * from "./LogOrders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports